import React, { useContext } from 'react';
import { Box, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import LogoImage from '../../../assets/logoEatClub.svg';
import { NavigationContext } from '../../../utils/navigationContext';
import useStyles from './MobileHeaderStyles';

const MobileHeader = () => {
  const classes = useStyles();
  const { showNavigation, setShowNavigation } = useContext(NavigationContext);

  return (
    <Box className={classes.mobileHeader}>
      <IconButton color='inherit' aria-label='open drawer' edge='start' onClick={setShowNavigation}>
        <MenuIcon />
      </IconButton>
      <LogoImage className={classes.menuLogo} fill='#313131' />
    </Box>
  );
};

export default MobileHeader;
